import { render, staticRenderFns } from "./DeParaEmbarcadores.vue?vue&type=template&id=24638b9a"
import script from "./DeParaEmbarcadores.vue?vue&type=script&lang=js"
export * from "./DeParaEmbarcadores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports